<template>
  <div
    v-click-outside="onClickOutside"
    :class="[$style.vgp_time_picker, visible && $style.visible]"
  >
    <div>
      <div
        v-show="backButton"
        :class="$style['picker-header']"
        @click="$emit('backToDate', $event)"
      >
        <svg-sprite
          :name="'arrow-left'"
          :type="'regular'"
          :size="24"
        />
        <div :class="$style['picker-header_title']">
          {{ locales('back_button') }}
        </div>
      </div>
      <div :class="$style.time_data">
        <div :class="[$style.hours_data, timeFormat ? $style.hours_data_time_format : '']">
          <div :class="$style.hours_data_label">
            {{ locales('history_Hours') }}
          </div>
          <div :class="$style['digits-wrapper']">
            <div
              v-for="item in defHours"
              :key="item"
            >
              <div
                v-if="timeFormat"
                :class="[$style.number,
                         hours.includes(item) ? '' : $style.disabled,
                         localSelectH === item ? $style.selected : '']"
              >
                <label>
                  <input
                    v-model="hourSelected"
                    type="radio"
                    :value="item"
                  >
                  <span :class="$style.number_label">{{ item < 10 ? `0${item}` : item }}</span></label>
              </div>
              <div
                v-else
                :class="{
                  [$style.disabled]: (amTime && !am.includes(item)) || (!amTime && !pm.includes(item)),
                  [$style.number]: true,
                  [$style.selected]: (amTime && ((localSelectH === item && localSelectH !== 12) || (localSelectH === 0 && item === 12)))
                    || (!amTime && ((localSelectH - 12) === item || ((localSelectH - 12) === 0 && item === 12)))
                }"
              >
                <label>
                  <input
                    v-model="hourSelected"
                    type="radio"
                    :name="item"
                    :value="!amTime ? item + 12 : item"
                  >
                  <span :class="$style.number_label">{{ item < 10 ? `0${item}` : item }}</span></label>
              </div>
            </div>
          </div>
        </div>
        <div :class="$style.separator_line" />
        <div :class="[$style.min_data, timeFormat ? $style.min_data_time_format : '']">
          <div :class="$style.hours_data_label">
            {{ locales('common_minutes') }}
          </div>
          <div :class="$style['digits-wrapper']">
            <div v-for="item in minutes">
              <div :class="[$style.number, localSelectM === item ? $style.selected : '']">
                <label>
                  <input
                    v-model="minuteSelected"
                    type="radio"
                    :value="item"
                  >
                  <span :class="$style.number_label">{{ item < 10 ? `0${item}` : item }}</span></label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!timeFormat"
        :class="$style.time_tabs"
      >
        <vgp-tabs
          :tabs="tabs"
          :active="activeTime"
          :active-by="'type'"
          :type="'button'"
          :small="true"
          @onToggle="activateElement"
        />
      </div>
    </div>

    <div :class="$style['button-area']">
      <vgp-button
        :type="'primary'"
        :label="locales('set_button')"
        :small="true"
        @onClick="setTime"
      />
    </div>
  </div>
</template>

<script>
import vgpButton from '$$uiKitComp/globalButton/vgpButton.vue';
import vgpTabs from '$$uiKitComp/tabs/vgpTabs.vue';
import svgSprite from '$$uiKitComp/VueIcon/svgSprite.vue';

export default {
  name: 'VgpTimePicker',
  components: { vgpTabs, vgpButton, svgSprite },
  props: {
    currentDate: {
      type: Date,
      default: new Date(),
    },
    backButton: {
      type: Boolean,
      default: false,
      required: false,
    },
    timeData: {
      type: Object,
      default: () => ({}),
      required: false,
    },
    dateType: {
      type: String,
      default: 'start_date',
      required: false,
    },
    minuteStep: {
      type: Number,
      default: 5,
      required: false,
    },
    timeFormat: {
      type: Number,
      default: 1,
      required: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'changeTime',
    'backToDate',
    'closePicker',
  ],
  data() {
    return {
      locales: __,
      showTimePicker: false,
      hours: [],
      minutes: [],
      amTime: true,
      tabs: [
        {
          title: 'AM',
          type: 'am',
          width: 55,
        },
        {
          title: 'PM',
          type: 'pm',
          width: 55,
        },
      ],
      localSelectH: null,
      localSelectM: null,
      value: null,
    };
  },
  computed: {
    date() {
      return this.currentDate;
    },
    activeTime() {
      return this.currentDate.getHours() < 12 ? {
        title: 'AM',
        type: 'am',
      } : {
        title: 'PM',
        type: 'pm',
      };
    },
    defHours() {
      const result = [];

      if (this.timeFormat) {
        for (let i = 0; i < 24; i++) {
          result.push(i);
        }
      } else {
        return Array.from({ length: 12 }, (_, i) => (i + 11) % 12 + 1);
      }

      return result;
    },
    selectedHour() {
      return this.currentDate.getHours();
    },
    selectedMin() {
      return this.currentDate.getMinutes();
    },
    hourSelected: {
      get() {
        return this.localSelectH || '';
      },

      set(newVal) {
        if (this.hours.includes(newVal)
                || (this.amTime && this.am.includes(newVal)) || (!this.amTime && this.pm.includes(newVal % 12 || 12))) {
          this.localSelectH = newVal;
        }
      },
    },
    minuteSelected: {
      get() {
        return this.localSelectM || '';
      },

      set(newVal) {
        this.localSelectM = newVal;
      },
    },

    am() {
      if (this.timeData && !Object.keys(this.timeData).length) {
        return this.hours;
      }

      return this.hours.map(hour => {
        if (hour < 12 && hour !== 0) return hour;
        if (hour === 0) return 12;
      }).filter(hour => hour !== undefined);
    },
    pm() {
      if (this.timeData && !Object.keys(this.timeData).length) {
        return this.defHours;
      }

      return this.hours.map(hour => {
        if (hour > 12) return hour - 12;
        if (hour === 12) return hour;
      }).filter(hour => hour !== undefined);
    },
  },
  watch: {
    currentDate: {
      handler(val) {
        this.localSelectH = this.selectedHour;
        this.localSelectM = this.selectedMin;
      },
      immediate: true,
    },
  },
  created() {
    this.amTime = this.selectedHour < 12;
    this.getHours();
    this.getMinutes();
  },
  methods: {
    setTime() {
      const date = new Date(this.currentDate);

      date.setHours(this.localSelectH);
      date.setMinutes(this.localSelectM);
      this.value = date;
      this.$emit('changeTime', this.value);
    },
    selectTimePicker() {
      this.showTimePicker = !this.showTimePicker;
    },
    activateElement(payload) {
      this.amTime = payload.type === 'am';
    },
    getMinutes() {
      const minutes = [];

      for (let i = 0; i < 60; i += this.minuteStep) {
        minutes.push(i);
      }

      this.minutes = minutes;
    },
    onClickOutside() {
      this.$emit('closePicker');
    },
    getHours() {
      const hours = [];

      if (this.timeData && Object.keys(this.timeData).length) {
        if (this.dateType === 'start_date') {
          this.timeData.forEach(data => {
            const dif = data.endHour - data.startHour;

            for (let i = 0; i < dif; i++) {
              hours.push(data.startHour + i);
            }
          });
        }
        if (this.dateType === 'end_date') {
          this.timeData.forEach(data => {
            const dif = data.endHour - data.startHour;

            for (let i = 0; i <= dif; i++) {
              hours.push(data.startHour + i);
            }
          });
        }
      }
      this.hours = !this.dateType ? this.defHours : hours;
    },
  },
};

</script>

<style module src="./vgpTimePicker.less" lang="less"></style>
